import { router } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { cn } from "@/lib/utils"
import type { PagyMetadata } from "@/types"

const PER_PAGE_OPTIONS = ["20", "50", "100"]

type Props = {
  pagy: PagyMetadata
  baseUrl: string
  filters?: Record<string, unknown>
  className?: string
}

export function Pagination({ pagy, baseUrl, filters = {}, className }: Props) {
  if (pagy.pages <= 1 && pagy.count <= 20) return null

  const navigate = (page: number, limit?: number) => {
    router.get(baseUrl, { q: filters as Record<string, string>, page, limit: limit ?? pagy.items }, { preserveState: true })
  }

  return (
    <div className={cn("flex items-center justify-between px-2 py-4", className)}>
      <div className="flex items-center gap-3">
        <p className="text-muted-foreground text-sm">
          {pagy.from}–{pagy.to} sur {pagy.count} résultats
        </p>
        <Select value={String(pagy.items)} onValueChange={(value) => navigate(1, Number(value))}>
          <SelectTrigger size="sm">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {PER_PAGE_OPTIONS.map((option) => (
              <SelectItem key={option} value={option}>
                {option} / page
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {pagy.pages > 1 && (
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" onClick={() => pagy.prev && navigate(pagy.prev)} disabled={!pagy.prev}>
            <ChevronLeft className="size-4" />
            Précédent
          </Button>
          <span className="text-muted-foreground text-sm">
            Page {pagy.page} / {pagy.pages}
          </span>
          <Button variant="outline" size="sm" onClick={() => pagy.next && navigate(pagy.next)} disabled={!pagy.next}>
            Suivant
            <ChevronRight className="size-4" />
          </Button>
        </div>
      )}
    </div>
  )
}
